<div class="grid grid-cols-1 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)] gap-4 items-stretch">
  <div class="w-full h-[20rem] md:h-[28rem] relative">
    <canvas baseChart
            [type]="chartType()"
            [data]="chartData()"
            [options]="chartOptions()"
            class="w-full h-auto md:h-full">
    </canvas>
    @if (loading) {
      <div class="absolute inset-0 flex items-center justify-center bg-white dark:bg-black pointer-events-none select-none">
        <div class="flex items-center space-x-2 text-gray-700 text-sm">
          <svg class="animate-spin h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <span>…</span>
        </div>
      </div>
    }
  </div>

  <div class="h-[20rem] md:h-[28rem] overflow-x-auto pr-1">
    @if (debugTables.length === 0) {
      <div class="text-sm text-gray-500">Keine Node-Daten.</div>
    } @else {
      <div class="flex h-full space-x-3">
        @for (table of debugTables; track table.name + '-' + $index; let idx = $index) {
          <div class="border border-gray-200 rounded-md bg-white flex-none min-w-[14rem]">
            <div class="px-3 py-2 border-b border-gray-200 bg-gray-100 text-sm">
              <div class="font-semibold">{{ table.name || ('Node ' + (idx + 1)) }}</div>
            </div>
            <div class="max-h-full overflow-y-auto">
              <table class="w-full text-xs">
                <thead class="sticky top-0 bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th class="text-left px-2 py-1 font-semibold">timestamp</th>
                    <th class="text-right px-2 py-1 font-semibold">value</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of table.rows; track row.timestamp + '-' + $index) {
                    <tr class="border-b border-gray-100">
                      <td class="px-2 py-1 align-top font-mono whitespace-nowrap">{{ formatTimestamp(row.timestamp) }}</td>
                      <td class="px-2 py-1 align-top text-right font-mono">{{ formatDebugValue(row.value) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
